import { Header as Container } from './styles'

export function DrawerHeader({ children, name, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
